import Column from '@sdk/components/ui/spacing/Column';
import { AttestationOption } from '@sdk/automatedBreaks/types/Attestation';
import { getShiftActualCurrentDuration, isWaivingAllowed } from '@sdk/automatedBreaks/utils';

import AnimatedRow from '@kiosk/common/components/Forms/AnimatedRow';
const ATTESTATION_TYPE_FIELD_NAME = 'attestationType';
import RadioButton from '@kiosk/common/components/ui/RadioButton/RadioButton';
import { DELAY } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/SelectAutomatedBreakView/selectAutomatedBreakView.constants';
import { useAutomatedBreaksContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedBreaksProvider/AutomatedBreaksProvider';
import { getAttestationOptions } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AttestationView/attestationView.utils';
import { Attestation } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AttestationView/attestationView.types';
import { useClockedInViewContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/ClockedInViewProvider/ClockedInViewProvider';

type Props = {
  currentAttestationItem: Attestation;
  onClick: (value: AttestationOption) => void;
};

const AttestationOptions = ({ currentAttestationItem, onClick }: Props) => {
  const { automatedBreaksSettings, orgSettings } = useAutomatedBreaksContext();
  const { shift } = useClockedInViewContext();

  const includeWaiveOption = isWaivingAllowed({
    automatedBreakType: currentAttestationItem.breakType,
    breakNumber: currentAttestationItem.breakNumber,
    currentShiftDurationMinutes: getShiftActualCurrentDuration(shift, orgSettings),
    orgSettings
  });

  const attestationOptions = getAttestationOptions(
    currentAttestationItem,
    automatedBreaksSettings,
    includeWaiveOption
  );

  return (
    <Column>
      {attestationOptions.map((item, index) => (
        <AnimatedRow
          borderTop
          key={currentAttestationItem.id + item.value}
          noPaddingHorizontal
          delay={DELAY}
          borderBottom={index === attestationOptions.length - 1}
          onClick={e => {
            if (e.target.name === ATTESTATION_TYPE_FIELD_NAME) {
              onClick((e.target.value as any) as AttestationOption);
            }
          }}>
          <RadioButton
            fieldName={ATTESTATION_TYPE_FIELD_NAME}
            label={item.description}
            value={item.value}
            checked={item.value === currentAttestationItem.option}
          />
        </AnimatedRow>
      ))}
    </Column>
  );
};

export default AttestationOptions;
